import { render, staticRenderFns } from "./EditGame.vue?vue&type=template&id=36c30c36&scoped=true"
import script from "./EditGame.vue?vue&type=script&lang=js"
export * from "./EditGame.vue?vue&type=script&lang=js"
import style0 from "./EditGame.vue?vue&type=style&index=0&id=36c30c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c30c36",
  null
  
)

export default component.exports